import axiosInstance from "api/axiosInstance";
import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";

export default function AdminPlanModal({
    isOpen,
    closeModal,
    modalData,
}) {
    const accessToken = useSelector(
        (state) => state.auth.accessToken
    );

    const [subscription, setSubscription] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (!isOpen || !modalData?.id) {
            return;
        }

        const getSubscription = async () => {
            try {
                setLoading(true);
                setError(null);

                const id =
                    modalData.id;
                const res = await axiosInstance.get(
                    `admin/businesses/${id}/subscription`,
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );

                setSubscription(res.data.data);
            } catch (error) {
                console.error(
                    "خطا در دریافت اطلاعات اشتراک:",
                    error
                );

                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getSubscription();
    }, [
        isOpen,
        modalData?.id,
        accessToken,
    ]);

    if (!modalData) {
        return null;
    }

    const owner = modalData.owner || {};

    const fullName =
        `${owner.firstName || ""} ${owner.lastName || ""}`.trim();

    const phone =
        `${owner.countryCode || ""}${owner.phone || ""}`;

    return (
        <div
            className={`fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50 ${isOpen ? "block" : "hidden"
                }`}
        >
            <div className="p-6 rounded-lg max-w-[500px] w-full bg-white max-h-[90vh] overflow-y-auto ">

                {/* Header */}
                <div className="flex justify-between items-center border-b pb-3">
                    <h3 className="text-xl font-bold text-[#1B4748]">
                        اطلاعات طرح خریداری شده{" "}
                        {modalData.username || "-"}
                    </h3>

                    <button
                        onClick={closeModal}
                        className="text-red-500"
                    >
                        <FaTimes className="text-xl" />
                    </button>
                </div>

                {/* Information */}
                <div className="mt-4">

                    {loading && (
                        <p className="text-gray-500 mt-4">
                            در حال دریافت اطلاعات اشتراک...
                        </p>
                    )}

                    {error && (
                        <p className="text-red-500 mt-4">
                            دریافت اطلاعات اشتراک ناموفق بود.
                        </p>
                    )}

                    {subscription && (

                        <div className="mt-4 p-3 rounded-lg">
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong>وضعیت طرح : </strong>
                                {subscription.subscription.isActive ? "فعال" : "غیرفعال" || "-"}
                            </p>
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong>نام طرح : </strong>
                                {subscription.plan.name || "-"}
                            </p>
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong> قیمت طرح : </strong>
                                {subscription.plan.price.toLocaleString() || "-"}
                            </p>
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong> درصد تخفیف : </strong>
                                {subscription.plan.offPercentage || "-"}
                            </p>
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong>تعداد توکن باقی مانده : </strong>
                                {subscription.subscription.remainingTokens.toLocaleString() || "-"}
                            </p>
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong>مدت زمان اعتبار طرح : </strong>
                                {subscription.plan.duration || "-"} روز
                            </p>
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong>تاریخ خرید طرح : </strong>
                                {subscription.subscription.startDate || "-"}
                            </p>
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong>تاریخ پایان طرح : </strong>
                                {subscription.subscription.endDate || "-"}
                            </p>
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong> طرح رایگان اولیه : </strong>
                                {subscription.plan.isBase ? "بله" : "خیر" || "-"}
                            </p>
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong> حداکثر کاراکتر مصرفی مجاز : </strong>
                                {subscription.plan.charLimit.toLocaleString() || "-"}
                            </p>
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong> حداکثر توکن ارسالی از کاربر : </strong>
                                {subscription.plan.userTokens.toLocaleString() || "-"}
                            </p>
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong> تعداد پیام روزانه مجاز  : </strong>
                                {subscription.plan.messagePerDay.toLocaleString() || "-"}
                            </p>
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong> تعداد کاربر : </strong>
                                {subscription.plan.userLimit.toLocaleString() || "-"}
                            </p>
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong>درصد کارمزد پلتفرم : </strong>
                                {subscription.plan.platformPercent || "-"}
                            </p>
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong> حداکثر توکن مجاز پرامپت سیستمی : </strong>
                                {subscription.plan.promptTokens.toLocaleString() || "-"}
                            </p>
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong> حداکثر توکن مجاز برای بارگذاری هر فایل : </strong>
                                {subscription.plan.fileTokens.toLocaleString() || "-"}
                            </p>
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong> تمدید خودکار طرح : </strong>
                                {subscription.subscription.autoRenewal ? "دارد" : "ندارد" || "-"}
                            </p>
                            
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong>مدل زبانی : </strong>
                                {subscription.perms.aiModels
                                    ?.map((item) => item.persianName)
                                    .join(" ، ")}
                            </p>
                            
                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong> مدل برداری : </strong>
                                {subscription.perms.embedders
                                    ?.map((item) => item.persianName)
                                    .join(" ، ")}
                            </p>

                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong> دسترسی به صفحات : </strong>
                                {subscription.perms.pages
                                    ?.map((item) => item.persianName)
                                    .join(" ، ")}
                            </p>

                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong> پلتفرم شبکه های احتماعی : </strong>
                                {subscription.perms.socialPlatforms
                                    ?.map((item) => item.persianName)
                                    .join(" ، ")}
                            </p>

                            <p className="mb-2 text-justify  max-h-[7.5rem] whitespace-pre-wrap">
                                <strong> ابزار ها : </strong>
                                {subscription.perms.tools
                                    ?.map((item) => item.persianName)
                                    .join(" ، ")}
                            </p>

                        </div>
                    )}
                </div>

            </div>
        </div>
    );
}
